import { CmsHelpTrainingView } from '../../../components/Cms';

export function HelpDetail() {
  return <CmsHelpTrainingView />;
}
